import { cache } from "react";
import { createSupabaseServerClient } from "./supabase";

export interface Metadata {
  id: number;
  last_modified_checkpoint: number;
  total_topsellers_pages: number;
  total_wishlist_pages: number;
  total_followers_pages: number;
  total_ccu_pages: number;
  total_apps_pages: number;
}

/**
 * Отримує metadata з таблиці metadata з кешуванням
 * Використовує React cache для дедуплікації запитів в межах одного рендеру
 */
export const getMetadata = cache(async (): Promise<Metadata | null> => {
  const supabase = await createSupabaseServerClient();

  const { data, error } = await supabase
    .from("metadata")
    .select("*")
    .eq("id", 1)
    .single();

  if (error) {
    console.error("Failed to fetch metadata:", error);
    return null;
  }

  return data as Metadata;
});
